import { timeline } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

const phaseStyle: Record<string, string> = {
  起因: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  发酵: 'bg-accent-100 text-accent-800 border-accent-200',
  高潮: 'bg-primary-100 text-primary-700 border-primary-200',
  后续: 'bg-background-200 text-foreground-700 border-background-300',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-5xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
              TIMELINE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              海角黑料事件时间线
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-500 md:text-right">
            下方按时间顺序排列全部关键节点，每个节点标注阶段与日期，顺着读即可掌握完整经过。
          </p>
        </div>

        <div className="relative mt-10">
          <span className="absolute bottom-0 left-[18px] top-2 w-px bg-background-300 md:left-1/2" />

          <div className="space-y-8 md:space-y-4">
            {timeline.map((item, index) => {
              const isEven = index % 2 === 0;
              return (
                <div key={item.date} className="relative pl-12 md:pl-0">
                  <span className="absolute left-[11px] top-3 flex h-4 w-4 items-center justify-center md:left-1/2 md:-translate-x-1/2">
                    <span className="absolute h-4 w-4 rounded-full bg-primary-100" />
                    <span className="relative h-2 w-2 rounded-full bg-primary-500" />
                  </span>

                  <div className="md:grid md:grid-cols-2 md:items-center md:gap-12">
                    <Reveal
                      className={isEven ? 'md:pr-4' : 'md:order-2 md:pl-4'}
                    >
                      <article className="rounded-lg border border-background-200 bg-background-50 p-5">
                        <div className="flex flex-wrap items-center gap-2">
                          <span
                            className={`rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${
                              phaseStyle[item.phase] ??
                              'border-background-300 bg-background-200 text-foreground-700'
                            }`}
                          >
                            {item.phase}
                          </span>
                          <span className="font-heading text-xs font-bold tracking-wide text-foreground-500">
                            {item.date}
                          </span>
                        </div>
                        <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                          {item.desc}
                        </p>
                      </article>
                    </Reveal>

                    <Reveal
                      delay={80}
                      className={`mt-3 md:mt-0 ${isEven ? 'md:pl-4' : 'md:order-1 md:pr-4'}`}
                    >
                      <div className="h-[180px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[190px]">
                        <img
                          src={item.image}
                          alt={`${item.date} 海角黑料事件经过节点`}
                          title={`海角黑料事件经过 ${item.title}`}
                          className="h-full w-full object-top"
                        />
                      </div>
                    </Reveal>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg border border-accent-200 bg-accent-50 p-5 sm:flex-row">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-bookmark-3-line text-lg" />
            </span>
            <p className="text-sm text-foreground-700">
              以上为海角黑料始末的完整节点，可结合下方「后续进展」继续阅读。
            </p>
          </div>
          <a
            href="#followup"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
          >
            看后续进展
            <i className="ri-arrow-down-line" />
          </a>
        </div>
      </div>
    </section>
  );
}